<div *ngIf="descriptor" class="vedrax-dynamic-container" [formGroup]="form">

    <div [formArrayName]="descriptor.controlName">

        <mat-accordion class="vedrax-card-dynamic">

            <mat-expansion-panel class="vedrax-panel" *ngFor="let control of formArray.controls; let i = index;" [formGroupName]="i">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <vedrax-title [descriptor]="descriptor" [index]="i"></vedrax-title>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <vedrax-control *ngFor="let ctrl of descriptor.controlChildren" [descriptor]="ctrl"
                    [control]="getChildControl(control, ctrl)"></vedrax-control>

                <mat-action-row>

                    <button class="remove-param" mat-icon-button aria-label="remove" (click)="remove(i)">
                        <mat-icon>delete</mat-icon>
                    </button>

                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>

        <button color="primary" class="add-param" mat-stroked-button aria-label="add" (click)="add()">
            <mat-icon>add</mat-icon>
            {{descriptor.controlLabel}}
        </button>

    </div>

</div>